import React from 'react'
import Twisthumanpart from './Twisthumanpart'
// import { IconAlternate } from 'components/molecules';


export const services = [
    {
      icon: 'fas fa-calendar-day',
      title: 'Exceptional Performance',
      subtitle:
        	'High fidelity double stranded DNA probes with optimized performance thanks to probe boosting and efficient amplification.	NGS QC of all probes with Uniform enrichment of target regions with no unexpected dropouts and unparalleled specificity even at high sequencing depths.'
        
        
    },

    
    {
      icon: 'fas fa-memory',
      title: 'Maximum Capture Efficiency',
      subtitle:
        ' ⦁	High enrichment uniformity means you can increase the depth of sequencing, or throughput to reduced overall sequencing cost',
    },
    {
      icon: 'fas fa-dna',
      title: 'Greater Flexibility',
      subtitle:
        "⦁	Modular kit structure enables workflow flexibility , ⦁	Customization tools allow the rapid and scalable implementation of custome exome ",
    },
  ];

function Twisthuman() {
    return (
        <div>
           <Twisthumanpart data = {services}/> 
        </div>
    )
}

export default Twisthuman;
